/** Alineado con TareaRepository.INCIDENT_LINKED_CLASIFICACIONES (backend). */
export const INCIDENT_LINKED_CLASIFICACION_VALUES = [
  'incidente',
  'investigacionIncidente',
] as const;

export type IncidentLinkedClasificacion =
  (typeof INCIDENT_LINKED_CLASIFICACION_VALUES)[number];

export function isIncidentLinkedClasificacion(
  clasificacion?: string | null,
): clasificacion is IncidentLinkedClasificacion {
  return (
    clasificacion != null &&
    (INCIDENT_LINKED_CLASIFICACION_VALUES as readonly string[]).includes(clasificacion)
  );
}

/** Filtro API tarea/modeloTarea: ambas clasificaciones vinculadas a incidente */
export const CLASIFICACION_FILTER_INCIDENT_LINKED = [
  'incidente',
  'investigacionIncidente',
] as const;
